exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container.shadowed[data-v-10b9e1f3] {\n  border-radius: 8px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);\n  background-color: white;\n  width: 100%;\n  height: auto;\n  min-height: 100px;\n  padding: 40px;\n}", ""]);

// exports
